/**
 * Derived numbers a coach would otherwise work out on paper.
 *
 * These are presented as what they are — arithmetic on what was entered, not
 * measurements — and every one of them feeds the expected-load engine in M3.
 */

/** Square metres per player. The single strongest lever on intensity in a game. */
export function areaPerPlayer(
  length: number | null | undefined,
  width: number | null | undefined,
  players: number | null | undefined,
): number | null {
  if (!length || !width || !players || players <= 0) return null;
  return Math.round(((length * width) / players) * 10) / 10;
}

/** Work-to-rest as a normalised ratio, e.g. 1:2. */
export function workRestRatio(
  work: number | null | undefined,
  rest: number | null | undefined,
): string | null {
  if (!work || work <= 0) return null;
  if (rest === null || rest === undefined) return null;
  if (rest === 0) return '1:0';
  const ratio = rest / work;
  return ratio >= 1
    ? `1:${Math.round(ratio * 10) / 10}`
    : `${Math.round((work / rest) * 10) / 10}:1`;
}

/** Total work time across sets and reps, in minutes. */
export function totalWorkMinutes(
  workSeconds: number | null | undefined,
  reps: number | null | undefined,
  sets: number | null | undefined,
): number | null {
  if (!workSeconds) return null;
  const total = workSeconds * (reps ?? 1) * (sets ?? 1);
  return Math.round((total / 60) * 10) / 10;
}
